/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Minimumoutsideairdampersactualsetpoint5Inputs */



/**
* | output |
* | --- |
* | "Fresh air damper actual setpoint" |
*
* @param {Ahu_History_Key_Minimumoutsideairdampersactualsetpoint5Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_minimumoutsideairdampersactualsetpoint5 = /** @type {((inputs?: Ahu_History_Key_Minimumoutsideairdampersactualsetpoint5Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Minimumoutsideairdampersactualsetpoint5Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fresh air damper actual setpoint")
	return /** @type {LocalizedString} */ ("Consigne volet air neuf")
});
export { ahu_history_key_minimumoutsideairdampersactualsetpoint5 as "ahu_history_key_minimumOutsideAirDampersActualSetpoint" }